import { Col, ListGroup, Row } from "react-bootstrap";
import { CompetitionPickerListView } from "./CompetitionPickerViews";
import { Competition, CompetitionChoice } from "../../../models/interfaces/Competition";
import { useCallback } from 'react';
import { useTimedLoad } from '../../../helpers/useTimedLoad';
import { LoadStatus } from '../../../components/containers/LoadStatus';
import StyledListGroupItem from "../../../components/containers/StyledListGroupItem";
import { useHistory } from "react-router-dom";
import { parseTeamColor } from "../../../helpers/parseTeamColor";
import TeamRecordView from "../../competitions/modules/TeamRecordView";

interface Props {
    competitions: CompetitionChoice[];
    selectedCompetition: Competition;
    onSelectCompetition: (competition: CompetitionChoice) => void;
}

export function EventStandingsView({ competitions, selectedCompetition, onSelectCompetition }: Props) {
    const history = useHistory();
    const loadStandings = useCallback(() => selectedCompetition.standingsProvider.once(), [selectedCompetition]);
    const standings = useTimedLoad(loadStandings, 'standings');
    return (
        <div className="eventStandingsView" style={{width: '100%', paddingTop: '10px'}}>
            <Row noGutters className="matchContainer" style={{gap: '10px', padding: '20px'}}>
            <Col xs={4}>
                <CompetitionPickerListView
                    competitions={competitions}
                    selectedCompetition={selectedCompetition}
                    onCompetitionSelect={onSelectCompetition}
                />
            </Col>
            <Col>
                <LoadStatus {...standings} label="standings" />
                {standings.data?.length === 0 && <p>No standings available for this division.</p>}
                <ListGroup variant="flush">
                    {standings.data?.map(teamRecord => (
                            <StyledListGroupItem
                                key={teamRecord.team.id}
                                action
                                onClick={() => {
                                    history.push(
                                        `/competitions/${selectedCompetition.id}/entries/${teamRecord.team.id}`
                                    );
                                }}
                                color={parseTeamColor(teamRecord.team.color)}
                            >
                                <TeamRecordView teamRecord={teamRecord} />
                            </StyledListGroupItem>
                    ))}
                </ListGroup>
            </Col>
            </Row>
        </div>
    );
}